import { Config } from 'containers/AppContainer/typings';
import {
  DETAIL_JUGEMENT_ADD,
  PROCEDURE_STEPS,
} from 'containers/data-structure';
import { SUED_PARTY_DRIVER_ID } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/constants';
import {
  Idetails,
  ISuedParty,
} from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import { IJudgementAdd } from 'containers/LawyerLegalProceedingsPage/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { get, isEmpty, isNil } from 'lodash';
import {
  STATUS_PENDING,
  STATUS_REJECTED,
} from 'containers/LawyerFeeNote/constants';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import hash from 'object-hash';
import { COLORS } from 'constants/design';
import { GLOBAL_STATUS } from 'services/constants';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { formatIntervenants } from 'containers/RecapPage/utils';
import { formatInvoiceFeeNoteInfos } from 'containers/LawyerLegalProceedingsPage/utils';
import { isAllValuesIsNil } from 'helpers/utils';
import moment from 'moment';

export const getValueByCode = (code: number | string, list: Config[]) => {
  const item = list && list.find(item => Number(item.id) === Number(code));

  return item ? item.title : '';
};

export const getVehicules = (details: Idetails) => {
  const procedureDetails = { ...details };
  return procedureDetails[DETAIL_JUGEMENT_ADD.SUED_PARTIES].find(
    (el: ISuedParty) => el.suedParty === SUED_PARTY_DRIVER_ID,
  )?.vehicules;
};

export const activateMultipleJudgementAdd = (
  judgementAdd: IJudgementAdd | {},
  isManager: boolean,
) => {
  return !isEmpty(judgementAdd) &&
    featureService.hasFeature(FEATURES.ADD_MULTIPLE_JUDGEMENT_ADD) &&
    (!isManager ||
      (isManager &&
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER)))
    ? true
    : false;
};
export const toBeEdited = (
  judgementAddDocument: JudgementADDDocumentType,
  isManager: boolean,
) => get(judgementAddDocument, 'status', '') === STATUS_REJECTED && !isManager;

export const isDuplicateJudgementsAdd = (
  newJudgement: any,
  oldJudgementAddDocuments: any,
) => {
  const oldJudgementsHash = oldJudgementAddDocuments.map((el: any) =>
    hash({ ...el }),
  );
  return oldJudgementsHash.includes(hash(newJudgement));
};

export const renderColor = (status: string) => {
  switch (status) {
    case GLOBAL_STATUS.PENDING:
      return COLORS.PRIMARY_BUTTON_BLUE;
    case GLOBAL_STATUS.VALIDATED:
      return COLORS.GREEN;
    case GLOBAL_STATUS.REJECTED:
      return COLORS.RED;
    default:
      return COLORS.PRIMARY_BUTTON_BLUE;
  }
};

export const renderChipLabel = (status: string) => {
  switch (status) {
    case GLOBAL_STATUS.PENDING:
      return 'En cours';
    case GLOBAL_STATUS.VALIDATED:
      return 'Validée';
    case GLOBAL_STATUS.REJECTED:
      return 'Rejetée';

    default:
      return 'En cours';
  }
};

export const constructBodyJudgementAddMutipleToAdd = (
  judgementAdd: IJudgementAdd | {},
  propsJudgementAdd: {},
  newJudgementADDDocuments: JudgementADDDocumentType[],
  claimNumber: string,
  isManager: boolean,
  judiciaryProcessId: number,
  decisionGenerationFeeNote: boolean | null,
  assignedLawyersByJudiciaryProcess: any,
  withFeeNote: boolean,
  invoiceFeeNoteInfos: any,
  lawyerFirmRef: string | null,
  lawyerAssignment: any,
  invoiceNumber: string | null,
  invoiceDate: string | null,
  invoiceDocument: any,
  lawyerFirmReference: string | null,
) => {
  return {
    id: get(judgementAdd, 'id', ''),
    isLawyer: !isManager,
    lawyerCode: !isManager
      ? currentIntervenantStorage.get() &&
        currentIntervenantStorage.get().sagis_code
      : undefined,
    claimId: get(propsJudgementAdd, 'claimId', ''),
    judgementAddDocuments: newJudgementADDDocuments,
    claimNumber: claimNumber,
    procedureType: get(propsJudgementAdd, 'procedureType', ''),
    judiciaryProcessId: judiciaryProcessId,
    isInboxesActive: featureService.hasFeature(
      FEATURES.ATTRIBUTION_INBOXES_MANAGER,
    ),
    isTrackingActive: featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER),
    decisionGenerationFeeNote: decisionGenerationFeeNote,
    isCompanyIntervenants: formatIntervenants(
      assignedLawyersByJudiciaryProcess,
    ),
    invoiceFeeNoteInfos:
      withFeeNote &&
      isManager &&
      !isEmpty(invoiceFeeNoteInfos) &&
      featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE)
        ? formatInvoiceFeeNoteInfos(invoiceFeeNoteInfos)
        : [],
    lawyerFirmReference: lawyerFirmRef,
    assignementId: get(lawyerAssignment, 'id'),
    feeNote: withFeeNote
      ? {
          step: PROCEDURE_STEPS.JUDGEMENT_ADD,
          codeIntervenant:
            currentIntervenantStorage.get() &&
            currentIntervenantStorage.get().sagis_code,
          status: STATUS_PENDING,
          judgementDate: get(newJudgementADDDocuments, '[0].judgementDate', ''),
          invoiceFeeNote:
            featureService.hasFeature(FEATURES.BILLING_INFO_FEE_NOTE) &&
            !isManager &&
            !isAllValuesIsNil({
              invoiceNumber: invoiceNumber,
              invoiceDate: invoiceDate,
              ...invoiceDocument,
            })
              ? {
                  codeIntervenant:
                    currentIntervenantStorage.get() &&
                    currentIntervenantStorage.get().sagis_code,
                  createdBy:
                    currentIntervenantStorage?.get() &&
                    currentIntervenantStorage?.get()?.preferred_username,
                  invoiceNumber: invoiceNumber,
                  invoiceDate:
                    invoiceDate === 'Invalid date' ? null : invoiceDate,
                  receptionDate: moment().format('YYYY-MM-DD'),
                  ...invoiceDocument,
                  isIndexed: false,
                }
              : undefined,
          firmReference: isNil(lawyerFirmReference)
            ? lawyerFirmRef
            : lawyerFirmReference,
        }
      : undefined,
    isLawyerInboxesActive: featureService.hasFeature(FEATURES.LAWYER_INBOXES),
  };
};
